import styled from "styled-components";

const CheckboxGroup = styled.div`
  position: relative;
  z-index: 0;

  & > * + * {
    margin-top: -${(props) => props.theme.borders.width.small}px;
  }
`;

export default CheckboxGroup;
